module.exports = __webpack_public_path__ + "img/location-slash.d21bc91c.svg";